import { render, staticRenderFns } from "./VerificationPage.vue?vue&type=template&id=2b9ce6bd&scoped=true"
import script from "./VerificationPage.vue?vue&type=script&lang=ts"
export * from "./VerificationPage.vue?vue&type=script&lang=ts"
import style0 from "./VerificationPage.vue?vue&type=style&index=0&id=2b9ce6bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9ce6bd",
  null
  
)

export default component.exports